import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { BUSINESS, waLink } from "../lib/zoco";

export const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={waLink(`Hola ${BUSINESS.name}, me gustaría hacer un pedido.`)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Pedir por WhatsApp"
      className={`group fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 flex items-center gap-3 transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="hidden md:inline-flex bg-[#3B421A] text-[#FAF8F5] font-sans-z text-xs uppercase tracking-[0.22em] px-4 py-3 rounded-sm opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Pedir ahora
      </span>
      <span className="bg-[#25D366] hover:bg-[#1EBE5C] text-white p-4 rounded-full shadow-lg shadow-[#25D366]/30 transition-all duration-300 group-hover:scale-105 wa-pulse flex items-center justify-center">
        <MessageCircle size={26} strokeWidth={1.6} />
      </span>
    </a>
  );
};

export default WhatsAppFloat;
